import * as React from "react"
import { getStripe } from "../utils/stripe"

interface StaffingProductProps {
  sessionId: string
}

export default function StaffingProduct({ sessionId }: StaffingProductProps) {
  React.useEffect(() => {
    const redirectToCheckout = async () => {
      if (!sessionId) {
        console.error('No session ID provided')
        return
      }

      try {
        const stripe = await getStripe()
        if (!stripe) {
          console.error('Stripe failed to load')
          return
        }

        const { error } = await stripe.redirectToCheckout({ sessionId })
        
        if (error) {
          console.error('Error redirecting to checkout:', error)
        }
      } catch (err) {
        console.error('Error in redirectToCheckout:', err)
      }
    }

    // Auto-redirect when component mounts
    redirectToCheckout()
  }, [sessionId])

  return (
    <div className="staffing-product-checkout">
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '200px' }}>
        <div className="text-center">
          <div className="spinner-border text-primary mb-3" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
          <h4>Redirecting to checkout...</h4>
          <p className="text-muted">Please wait while we redirect you to our secure payment page.</p>
        </div>
      </div>
    </div>
  )
}
